import { StateStorage } from "../StateStorage";

export type Reducer<TState, TAction> = (state: TState, action: TAction) => TState;

export default function persistStateReducer<TState, TAction>(storage: StateStorage<TState>, initialState: TState, innerReducer: Reducer<TState, TAction>): Reducer<TState, TAction> {
    let obj = storage.get() ?? initialState;

    // Clean up transient visual state on page load - don't persist across browser refreshes
    // visible is derived from config (autoOpenOnWidth, autoOpenOnPattern) and visuals.opened
    if (obj && (obj as any).visuals) {
        obj = {
            ...obj,
            visuals: {
                ...(obj as any).visuals,
                hasInteracted: undefined,
                visible: undefined
            }
        };
    }

    return (state = obj, action) => {
        const res = innerReducer(state, action);
        storage.set(res);
        return res;
    };
}